//
//
//
//
//
//
//

export default {
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String,
    backgroundColor: String
  },
  methods: {
    getStyle () {
      if (!this.showLoading && this.tip) {
        return {
          'background-color': this.backgroundColor
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/load-more/index.vue